import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BookingsiteService } from "@root/router/booking-site/bookingsite.service";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "bs-listings-detail-basis",
  templateUrl: "./basis.component.html",
  styleUrls: ["./basis.component.scss"],
})
export class BsListingsDetailBasisComponent implements OnInit {
  @Input({ required: true }) thirdpartyAccountId;
  @Input({ required: true }) listingId;
  @Input() type: "self_hosted" | "hostex" = "hostex";
  @Input() inProgress = false;
  @Input()
  set priceInfo(value) {
    if (value) {
      this.form.patchValue(value);
    }
  }
  @Output() onUpdated = new EventEmitter();
  setPriceModal = false;

  form: FormGroup = this.fb.group({
    weekend_price: null,
    base_price: null,
  });

  bsOrigin;

  setFeesUrl;
  setRatePlanUrl;

  get showBasePriceIcon() {
    return !this.form.get("base_price").value;
  }

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private msg: NzMessageService,
    private bsSrv: BookingsiteService,
  ) {}

  ngOnInit() {
    let bsOrigin;
    if (location.href.includes(".test")) {
      bsOrigin = "http://bs.xiaogechuangxin.com/";
    } else {
      bsOrigin = "https://bookingsite.hostex.io/";
    }

    /**
     * 该字段主要用于控制 bs 房东端的 site 的显示与否
     * 如果路由中带有 from=hostex，则在房东端隐藏 site 功能
     */
    const fromAffix = this.type === "self_hosted" ? "?from=hostex" : "";

    this.setFeesUrl = this.bsSrv.generateBsUrl(bsOrigin + "listings/detail/" + this.listingId + fromAffix);
    this.setRatePlanUrl = this.bsSrv.generateBsUrl(bsOrigin + "rateplan" + fromAffix);
  }

  private requestSetPrice() {
    const params = {
      ...this.form.value,
      thirdparty_account_id: this.thirdpartyAccountId,
      listing_id: this.listingId,
    };
    this.http.post("/api/bs/listings/set_prices", params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.setPriceModal = false;
        this.onUpdated.emit();
        this.msg.success("Saved.");
      }
    });
  }

  onSetPrices() {
    this.requestSetPrice();
    // this.setPriceModal = false;
  }
}
